import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Fragment, PureComponent } from 'react';

import styles from './requestSimulatorFold.module.scss';

type PropsT = {
  className?: string;
  isArray: boolean;
  folded: boolean;
  foldKey: string;
  isLastLine: boolean;
};

type StateT = {
  folded: boolean;
};

export class RequestSimulatorFold extends PureComponent<PropsT, StateT> {
  name = 'RequestSimulatorFold';

  constructor(props: PropsT) {
    super(props);

    this.state = {
      folded: props.folded,
    };

    this.toggleFold = this.toggleFold.bind(this);
  }

  toggleFold() {
    const { folded } = this.state;
    this.setState({ folded: !folded });
  }

  render() {
    const { className, foldKey, isArray, isLastLine, children } = this.props;
    const { folded } = this.state;

    const braces = isArray ? ['[', ']'] : ['{', '}'];
    const name = foldKey ? `${foldKey}:` : '';

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    const endBrace = `${braces[1]}${isLastLine ? '' : ','}`;

    return (
      <div className={rootClass}>
        <div className={styles.clearFloat}>
          <button
            type="button"
            onClick={this.toggleFold}
            className={styles.toggle}
          >
            <span className={styles.toggleIcon}>
              <Icon name={folded ? 'plus' : 'minus'} />
            </span>
            <span className={styles.objectStart}>
              {`${name} ${braces[0]}`}
              {!!folded && (
                <Fragment>
                  <span className={styles.dots}>&hellip;</span>
                  {endBrace}
                </Fragment>
              )}
            </span>
          </button>
        </div>
        {!folded && (
          <Fragment>
            {!!children && <div className={styles.indented}>{children}</div>}
            <div className={styles.clearFloat}>{endBrace}</div>
          </Fragment>
        )}
      </div>
    );
  }
}
